import Services from "../components/Service"
import Customerquote from "./customerquote"
import { useDispatch, useSelector } from "react-redux";
import { React, useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import * as actions from '../actions/micustomeractions'

export default function MainCustomerPortal() {

    const state = useSelector(state => state.miCustomerSharedReducer);
    const location = useLocation();
    const dispatch = useDispatch();
    const modalState = state.modalState;

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const payment = queryParams.get("payment");
        const quote = queryParams.get("quote");

        const id = queryParams.get("enquiryId");
        if (payment) {
            dispatch(actions.handleNextStep(4))
        }

        const encryptedEnquiryRefId1 = queryParams.get("encryptedEnquiryRefId1");
        const encryptedEnquiryRefId2 = queryParams.get("encryptedEnquiryRefId2");
        if (encryptedEnquiryRefId1 && encryptedEnquiryRefId2) {
            dispatch(actions.showMedicalQuote());
            dispatch(actions.getQuoteInformation(/* id */{ encryptedEnquiryRefId1, encryptedEnquiryRefId2 }, true, quote));
            dispatch(actions.handleBasicInfoQuoteChange({ name: "enquiryId", value: id }));
            dispatch(actions.handleBasicInfoQuoteChange({ name: "encryptedEnquiryRefId1", value: encryptedEnquiryRefId1 }));
            dispatch(actions.handleBasicInfoQuoteChange({ name: "encryptedEnquiryRefId2", value: encryptedEnquiryRefId2 }));
            dispatch(actions.handleBasicInfoQuoteChange({ name: "quotationNo", value: id }));
        }
        else {
            dispatch(actions.showMedicalServices());
        }
    }, [location]);

    return (
        <div>
            {/* {modalState.showService && <Services />} */}
            <Customerquote />
            {/* {modalState.showMedicalQuote && } */}
        </div>
    )
}